import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { CommitmentFormGroup, ContractCommitment } from '@core/models/contract-commitment.model';
import { MatSnackBar } from '@angular/material/snack-bar';;

@Component({
standalone: false,
  selector: 'app-commitment-group',
  templateUrl: './commitment-group.component.html',
  styleUrls: ['./commitment-group.component.scss'],
})
export class CommitmentGroupComponent implements OnInit, OnChanges {
  @Input() group: CommitmentFormGroup;
  @Input() isPastYearContract: boolean;
  @Output() commitmentsChange = new EventEmitter<any>();

  groupValue: any;
  groupForm: FormGroup;
  groupPrefix: string = 'commitment_';
  groupValueName: string = 'groupValue';
  groupErrors = [];

  constructor(private snackBar: MatSnackBar,  private fb: FormBuilder) {
    this.groupForm = this.fb.group({});
  }

  ngOnInit() {
    this.initForm();
    this.updateGroup();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.group && !changes.group.firstChange) {
      this.group.commitments.forEach(commitment => {
        if (!this.groupForm.get(this.groupPrefix + commitment.id)) {
          this.groupForm.addControl(this.groupPrefix + commitment.id, new FormControl(commitment.value));
        }
      });
      this.updateGroup();
    }
  }

  trackByCommitment(_index: number, commitment: ContractCommitment) {
    return commitment.id;
  }

  onInputChange(commitment: ContractCommitment) {
    if (!this.isPastYearContract) {
      this.groupValue = 0;
      this.groupErrors[this.groupPrefix + commitment.id] = this.groupForm.get(this.groupPrefix + commitment.id).errors;
      
      this.group.commitments?.forEach((commitment) => {
          commitment.value = Number(this.groupForm.getRawValue()[this.groupPrefix + commitment.id]) || 0;
          this.groupValue += commitment.value;

          if (commitment.template.parent) {
            const parent = this.group.commitments.find(c => c.template.id === commitment.template.parent);

            if (parent && parent.value < commitment.value) {
              this.groupForm.get(this.groupPrefix + parent.id).setValue(commitment.value);
              this.snackBar.open(
                'La valeur de l\'engagement \"' + commitment.template.title + '\" ne peut pas être supérieure à celle de son parent \"' + parent.template.title + '\"',
                'x',
                { duration: 5000 }
              );
              this.groupForm.get(this.groupPrefix + commitment.id).setValue(parent.value);
              commitment.value = parent.value;
            }
          }
      });
      
      this.commitmentsChange.emit(
        this.groupErrors[this.groupPrefix + commitment.id] ? false : this.group.commitments
      );
    }
  }

  public updateGroup() {
    this.groupValue = 0;

    this.group.commitments.forEach((commitment) => {
      this.groupForm.get(this.groupPrefix + commitment.id).setValue(commitment.value);
      if (commitment.template.parent == null) {
        this.groupValue += commitment.value;
      }
    });
  }

  protected initForm() {
    this.groupValueName = this.groupPrefix + this.group.category;
    this.groupForm.addControl(this.groupValueName , new FormControl(this.groupValue));
    this.group.commitments.forEach((commitment, index) => {
      this.groupForm.addControl(
        `${this.groupPrefix}${commitment.id}`,
        new FormControl(
          commitment.value,{
            validators: [
              () => {
                return this.validateCommitment(commitment) ? null : { invalidCommitment: true };
              }
            ]
          })
      );
    });
  }

  protected validateCommitment(commitment: ContractCommitment) {
    const currentValue = this.groupForm?.get(this.groupPrefix + commitment.id)?.value;

    const parent =
      this.group.commitments.find(c => c.id === commitment.template.parent);
    const children =
      this.group.commitments.filter(c => c.template.parent === commitment.id);

    if (parent && parent.value < currentValue) {
      return false;
    }

    if (children && children.length > 0) {
      const onError = children.find(c => c.value > currentValue);
      if (onError) {
        return false;
      }
    }
    return true;
  }
}
